import Vue from 'vue'
import moment from 'moment'
import { frontEndFormats } from '@/config'

Vue.filter('dateString', date => (date ? moment(date).format(frontEndFormats.DATE_FORMAT) : ''))
